/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GithubIssueViewModel } from '../../models/github-issue-view-model';

export interface GetGitHubIssues$Params {
}

export function GetGitHubIssues(http: HttpClient, rootUrl: string, params?: GetGitHubIssues$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GithubIssueViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetGitHubIssues.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GithubIssueViewModel>>;
    })
  );
}

GetGitHubIssues.PATH = '/api/Tickets/GetGitHubIssues';
